export default {"src":"/_next/static/media/btg.f288a0e9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};